<template>
  <label class="osk-product-comments-file-attach">
    <UikitIcon
      name="Photo"
      size="xl"
    />

    <input
      ref="inputAttach"
      class="osk-product-comments-file-attach__input"
      type="file"
      multiple
      @change="handleAttachFile"
    >
  </label>
</template>

<script setup lang="ts">
const inputAttach = ref<HTMLInputElement | null>(null);

const emit = defineEmits<{
  (e: 'fileAttach', file: File[]): void,
}>();

function handleAttachFile(e: Event) {
  if (!inputAttach.value) return;

  emit('fileAttach', [...(inputAttach.value.files ?? [])]);

  inputAttach.value.value = '';
}
</script>

<style scoped lang="scss">
@import "~/assets/scss/settings/index";

.osk-product-comments-file-attach {
  cursor: pointer;
  display: flex;
  align-items: center;

  &__input {
    display: none;
  }
}
</style>
